<header class="topbar">
  <div class="topbar-inner">
    <a class="brand" routerLink="/" aria-label="Notaryx, your timestamps">
      <app-icon name="stamp" [size]="26" />
      <span class="brand-name">Notaryx</span>
    </a>
    @if (auth.email(); as email) {
      <div class="account">
        <span class="account-email" [title]="email">{{ email }}</span>
        <!-- Settings only holds the file encryption switch for now (core/features.ts). -->
        @if (encryptionAvailable) {
          <a
            class="button ghost sm"
            routerLink="/settings"
            routerLinkActive="active"
            ariaCurrentWhenActive="page"
          >
            <app-icon name="settings" [size]="16" /> Settings
          </a>
        }
        <button class="ghost sm" (click)="signOut()" title="Sign out on all devices">
          <app-icon name="signout" [size]="16" /> Sign out
        </button>
      </div>
    }
  </div>
</header>

<main>
  <router-outlet />
</main>

@if (version) {
  <footer class="app-footer small" [title]="builtAt">Notaryx {{ version }}</footer>
}
